import iconComment from "@assets/images/comment-customer.svg";
import paperTeal from "@assets/images/paper-teal.svg";
import { Button, Grid } from "@material-ui/core";
import {
  TypeSubmit,
  ViewEditMode
} from "@saleor/changeOrderExport/views/ViewEditOrder/types";
import DatePicker from "@saleor/components/DatePicker";
import DecimalFormat from "@saleor/components/DecimalFormat";
import MyTypography from "@saleor/components/MyTypography";
import SingleSelectField from "@saleor/components/SingleSelectField";
import { SingleTextField } from "@saleor/components/SingleTextField";
import TextAreaField from "@saleor/components/TextAreaField";
import DialogError from "@saleor/createOrderExport/components/DialogError";
// import { AddressTypeEnum } from "@saleor/createOrderExport/components/OrderHeaderTab/types";
import {
  ContractExportOrderAllItemBySoNoQuery,
  OrderType,
  RealtimePartnerType,
  useGet_Realtime_PartnerMutation
} from "@saleor/graphql";
import { parseFmtDate } from "@saleor/utils/date";
import { getRandomNumber } from "@saleor/utils/getRandowNumber";
import moment from "moment-timezone";
import React, { memo, useEffect, useMemo, useState } from "react";
import { useIntl } from "react-intl";

import { getDataOrderTextByCodeAndItemNo, getFormik } from "./formik";
import ModalAddress from "./ModalAddress";
import useStyles from "./styles";

export interface OrderHeaderTabProps {
  dataExportOrder?: ContractExportOrderAllItemBySoNoQuery["exportOrderWithAllItemsBySoNo"];
  submitOrderCall?: number;
  handleSubmitOrder?: (value, type) => void;
  viewEditMode?: ViewEditMode;
  setDataOrderHeader?: (value) => void;
  dataOrderHeader: any;
  netPrice: number;
  cancelEditCall?: number;
  setBillToInsteaded: (value: string) => void;
  setShipToInsteaded: (value: string) => void;
}

const usageOptions = [
  {
    label: "",
    value: ""
  },
  {
    label: "100 - Container",
    value: "100"
  },
  {
    label: "200 - Break bulk",
    value: "200"
  },
  {
    label: "E - Replacement",
    value: "E"
  },
  {
    label: "M - Sample",
    value: "M"
  },
  {
    label: "S - Series",
    value: "S"
  }
];

const OrderHeaderTab: React.FC<OrderHeaderTabProps> = props => {
  const {
    dataExportOrder,
    submitOrderCall,
    handleSubmitOrder,
    viewEditMode,
    setDataOrderHeader,
    dataOrderHeader,
    netPrice,
    cancelEditCall,
    setBillToInsteaded,
    setShipToInsteaded
  } = props;
  const classes = useStyles();
  const intl = useIntl();
  const [typeAddress, setTypeAddress] = useState<RealtimePartnerType>(
    RealtimePartnerType.SHIP_TO
  );
  const [visibleModalAddress, setVisibleModalAddress] = useState<boolean>(
    false
  );
  const [visibleDialogError, setVisibleDialogError] = useState<boolean>(false);

  const handleApplyAddress = (value: string, type: RealtimePartnerType) => {
    switch (type) {
      case RealtimePartnerType.SHIP_TO:
        setDataOrderHeader({ ...dataOrderHeader, shipTo: value });
        formik.setFieldValue("shipTo", value);
        setShipToInsteaded(value);
        break;
      case RealtimePartnerType.BILL_TO:
        setDataOrderHeader({ ...dataOrderHeader, billTo: value });
        formik.setFieldValue("billTo", value);
        setBillToInsteaded(value);
        break;
    }
  };

  const getPortOfDischarge = () =>
    getDataOrderTextByCodeAndItemNo(dataExportOrder, "Z013", 0);
  const getPortOfLoading = () =>
    getDataOrderTextByCodeAndItemNo(dataExportOrder, "Z014", 0);
  const getDLCExpiryDate = () =>
    parseFmtDate(getDataOrderTextByCodeAndItemNo(dataExportOrder, "Z223", 0));
  const getDLCNo = () =>
    getDataOrderTextByCodeAndItemNo(dataExportOrder, "Z222", 0);
  const getDLCLatestDeliveryDate = () =>
    parseFmtDate(getDataOrderTextByCodeAndItemNo(dataExportOrder, "Z224", 0));
  const getSoldToCode = () => {
    let _soldToCode = "";
    // eslint-disable-next-line chai-friendly/no-unused-expressions
    dataExportOrder?.orderPartners?.forEach(orderPartner => {
      if (orderPartner?.partnerRole === "AG") {
        _soldToCode = orderPartner?.partnerNo;
      }
    });
    return _soldToCode;
  };

  const getSoldToAddressUpLine = () => {
    const _soldToAddress = dataExportOrder?.orderPartners?.find(
      orderPartner => orderPartner?.partnerRole === "AG"
    );
    return `${_soldToAddress?.partnerNo || ""} - ${_soldToAddress?.address[0]
      ?.nameForPartners || ""}`;
  };
  const getSoldToAddress = () => {
    const _soldToAddress = dataExportOrder?.orderPartners?.find(
      orderPartner => orderPartner?.partnerRole === "AG"
    );
    return `${_soldToAddress?.address[0]?.street || ""} ${_soldToAddress
      ?.address[0]?.strSuppl1 || ""} ${_soldToAddress?.address[0]?.strSuppl2 ||
      ""} ${_soldToAddress?.address[0]?.strSuppl3 || ""} ${_soldToAddress
      ?.address[0]?.location || ""} ${_soldToAddress?.address[0]?.district ||
      ""} ${_soldToAddress?.address[0]?.city || ""} ${_soldToAddress?.address[0]
      ?.postCode || ""}`;
  };
  // const getShippingMark = () =>
  //   getDataOrderTextByCodeAndItemNo(dataExportOrder, "Z004", 0);
  const getUOM = () =>
    getDataOrderTextByCodeAndItemNo(dataExportOrder, "Z019", 0);
  const getGWUom = () =>
    getDataOrderTextByCodeAndItemNo(dataExportOrder, "ZK35", 0);
  const getETD = () =>
    parseFmtDate(getDataOrderTextByCodeAndItemNo(dataExportOrder, "Z038", 0));
  const getETA = () =>
    parseFmtDate(getDataOrderTextByCodeAndItemNo(dataExportOrder, "Z066", 0));
  const getNoOfContainer = () =>
    getDataOrderTextByCodeAndItemNo(dataExportOrder, "Z022", 0);
  const getEndCustomer = () => {
    let _endCustomer = "";
    // eslint-disable-next-line chai-friendly/no-unused-expressions
    dataExportOrder?.orderPartners?.forEach(orderPartner => {
      if (orderPartner?.partnerRole === "ZI") {
        _endCustomer = `${orderPartner?.partnerNo} - ${orderPartner?.address?.[0]?.name}`;
      }
    });
    return _endCustomer;
  };
  const getContactPerson = () => {
    let _contactPerson = "";
    // eslint-disable-next-line chai-friendly/no-unused-expressions
    dataExportOrder?.orderPartners?.forEach(orderPartner => {
      if (orderPartner?.partnerRole === "AP") {
        _contactPerson = `${orderPartner?.partnerNo} - ${orderPartner?.address?.[0]?.name}`;
      }
    });
    return _contactPerson;
  };

  const getAuthor = () => {
    let _author = "";
    // eslint-disable-next-line chai-friendly/no-unused-expressions
    dataExportOrder?.orderPartners?.forEach(orderPartner => {
      if (orderPartner?.partnerRole === "AU") {
        _author = `${orderPartner?.partnerNo} - ${orderPartner?.address?.[0]?.name}`;
      }
    });
    return _author;
  };

  const getSalesEmployee = () => {
    let _salesEmployee = "";
    // eslint-disable-next-line chai-friendly/no-unused-expressions
    dataExportOrder?.orderPartners?.forEach(orderPartner => {
      if (orderPartner?.partnerRole === "VE") {
        _salesEmployee = `${orderPartner?.partnerNo} - ${orderPartner?.address?.[0]?.name}`;
      }
    });
    return _salesEmployee;
  };

  const getPayer = () => {
    let _payer = "";
    // eslint-disable-next-line chai-friendly/no-unused-expressions
    dataExportOrder?.orderPartners?.forEach(orderPartner => {
      if (orderPartner?.partnerRole === "RG") {
        _payer = `${orderPartner?.partnerNo} - ${orderPartner?.payerName}`;
      }
    });
    return _payer;
  };

  const formik = getFormik(dataExportOrder);

  useEffect(() => {
    if (cancelEditCall) {
      formik.resetForm();
    }
  }, [cancelEditCall]);

  const [
    getRealtimePartnerData,
    { data: realtimePartnerData }
  ] = useGet_Realtime_PartnerMutation({
    variables: {
      type: [RealtimePartnerType.SHIP_TO, RealtimePartnerType.BILL_TO],
      saleOrgCode: dataExportOrder?.salesOrg,
      soldToCode: getSoldToCode(),
      piMessageId: getRandomNumber(),
      distributionChannel: dataExportOrder?.distributionChannel,
      division: dataExportOrder?.division,
      orderType: OrderType.EXPORT
    }
  });

  const mappedRealtimePartnerData = useMemo(
    () => realtimePartnerData?.getSapRealtimePartner?.response,
    [realtimePartnerData]
  );

  const getRealTimePartnerDataByType = () => {
    if (typeAddress === RealtimePartnerType.SHIP_TO) {
      return mappedRealtimePartnerData?.filter(e => e.partnerFunction === "WE");
    }
    if (typeAddress === RealtimePartnerType.BILL_TO) {
      return mappedRealtimePartnerData?.filter(e => e.partnerFunction === "RE");
    }
  };

  const addressOptions = useMemo(() => getRealTimePartnerDataByType(), [
    typeAddress,
    realtimePartnerData
  ]);
  useEffect(() => {
    if (dataExportOrder?.contractNo) {
      getRealtimePartnerData();
    }
  }, [dataExportOrder?.contractNo]);

  const handleOpenAddress = (type: RealtimePartnerType) => {
    setTypeAddress(type);
    getRealtimePartnerData();
    setVisibleModalAddress(true);
  };

  const getTextError = field =>
    viewEditMode === ViewEditMode.EDIT ? (
      <div className={classes.textError} data-testid={`text-error-${field}`}>
        {formik.errors[field]}
      </div>
    ) : (
      ""
    );

  useEffect(() => {
    if (submitOrderCall) {
      if (formik.isValid) {
        handleSubmitOrder(formik.values, TypeSubmit.SUBMIT_HEADER);
      } else {
        handleSubmitOrder({ error: true }, TypeSubmit.SUBMIT_HEADER);
        // setVisibleDialogError(true);
      }
    }
  }, [submitOrderCall]);

  const onChangeField = event => {
    formik.handleChange(event);
    const newData = { ...dataOrderHeader };
    newData[event.target.name] = event.target.value;
    if (event.target.name === "requestDate") {
      const initData = moment(
        dataExportOrder?.requestDate,
        "DD/MM/YYYY"
      ).format("YYYY-MM-DD");
      const newDate = event.target.value;
      formik.setFieldValue("isRequestDateChange", initData !== newDate);
    }
    setDataOrderHeader(newData);
  };
  const handleChangeEtd = event => {
    const initData = moment(getETD()).format("DD/MM/YYYY");
    const newDate = event.target.value;
    formik.setFieldValue("isEtdChange", initData !== newDate);
    formik.setFieldValue("etd", newDate);
    const newData = { ...dataOrderHeader };
    newData[event.target.name] = event.target.value;
    setDataOrderHeader(newData);
  };

  const handleChangeEta = event => {
    const initData = moment(getETA()).format("DD/MM/YYYY");
    const newDate = event.target.value;
    formik.setFieldValue("isEtaChange", initData !== newDate);
    formik.setFieldValue("eta", event.target.value);
    const newData = { ...dataOrderHeader };
    newData[event.target.name] = event.target.value;
    setDataOrderHeader(newData);
  };

  return (
    <div className={classes.root}>
      <div className={classes.piNo}>
        <img src={paperTeal} alt="paper-teal" />
        <MyTypography variant={"h7"} className={classes.itemPiNo}>
          PI No.
        </MyTypography>
        <MyTypography
          variant={"h6"}
          className={classes.itemPiNo}
          data-testid="piNo-text"
        >
          {dataExportOrder?.contractNo}
        </MyTypography>
      </div>
      <div className={classes.mainContent}>
        <Grid container spacing={6}>
          <Grid item md={6} sm={12}>
            <Grid container spacing={3}>
              <Grid item md={12}>
                <MyTypography
                  variant={"subtitle3"}
                  className={classes.titleField}
                >
                  {intl.formatMessage({ defaultMessage: "Sold-To Party" })}
                </MyTypography>
                <div className={classes.soldToInfo}>
                  <MyTypography
                    variant={"body1"}
                    className={classes.textCode}
                    data-testid="soldToAddressUpLine-text"
                  >
                    {getSoldToAddressUpLine()}
                  </MyTypography>
                  <MyTypography
                    variant={"body3"}
                    className={classes.textAddress}
                    data-testid="soldToAddress-text"
                  >
                    {getSoldToAddress()}
                  </MyTypography>
                </div>
              </Grid>
              <Grid item md={6} sm={12}>
                <MyTypography
                  variant={"subtitle3"}
                  className={classes.titleField}
                >
                  {intl.formatMessage({ defaultMessage: "PO Date" })}
                </MyTypography>
                <MyTypography variant={"body3"} data-testid="poDate-text">
                  {dataExportOrder?.poDate}
                </MyTypography>
              </Grid>
              <Grid item md={6} sm={12}>
                <MyTypography
                  variant={"subtitle3"}
                  className={classes.titleField}
                >
                  {intl.formatMessage({ defaultMessage: "PO No." })}
                </MyTypography>
                {viewEditMode === ViewEditMode.VIEW ? (
                  <MyTypography variant={"body3"} data-testid="poNo-text">
                    {dataExportOrder?.poNo}
                  </MyTypography>
                ) : (
                  <SingleTextField
                    name={"poNo"}
                    value={formik.values.poNo}
                    onChange={onChangeField}
                    error={!!formik.errors.poNo}
                    maxLengthProps={35}
                    id="poNo"
                    InputProps={{
                      inputProps: { "data-testid": "poNo-input" }
                    }}
                  />
                )}
                {getTextError("poNo")}
              </Grid>
              <Grid item md={6} sm={12}>
                <MyTypography
                  variant={"subtitle3"}
                  className={classes.titleField}
                >
                  {intl.formatMessage({ defaultMessage: "Request Date" })}
                </MyTypography>
                {viewEditMode === ViewEditMode.VIEW ? (
                  <MyTypography
                    variant={"body3"}
                    data-testid="requestDate-text"
                  >
                    {dataExportOrder?.requestDate}
                  </MyTypography>
                ) : (
                  <DatePicker
                    name={"requestDate"}
                    id="requestDate"
                    data-testid="requestDate-input"
                    value={formik.values.requestDate}
                    onChange={onChangeField}
                    error={!!formik.errors.requestDate}
                    // disabled
                    noBlock
                  />
                )}
                {getTextError("requestDate")}
              </Grid>
              <Grid item md={6} sm={12}>
                <MyTypography
                  variant={"subtitle3"}
                  className={classes.titleField}
                >
                  {intl.formatMessage({ defaultMessage: "Ref. PI No." })}
                </MyTypography>
                {viewEditMode === ViewEditMode.VIEW ? (
                  <MyTypography variant={"body3"} data-testid="refPiNo-text">
                    {dataExportOrder?.refPiNo}
                  </MyTypography>
                ) : (
                  <SingleTextField
                    maxLengthProps={40}
                    name={"refPiNo"}
                    id="refPiNo"
                    InputProps={{
                      inputProps: { "data-testid": "refPiNo-input" }
                    }}
                    value={formik.values.refPiNo}
                    onChange={onChangeField}
                  />
                )}
              </Grid>
              <Grid item md={6} sm={12}>
                <MyTypography
                  variant={"subtitle3"}
                  className={classes.titleField}
                >
                  {intl.formatMessage({ defaultMessage: "Net Price" })}
                </MyTypography>
                <MyTypography variant={"body3"} data-testid="netPrice-text">
                  <DecimalFormat
                    value={netPrice}
                    isGrayDecimal={false}
                    countDecimal={2}
                  />
                </MyTypography>
              </Grid>
              <Grid item md={6} sm={12}>
                <MyTypography
                  variant={"subtitle3"}
                  className={classes.titleField}
                >
                  {intl.formatMessage({ defaultMessage: "Doc. Currency" })}
                </MyTypography>
                <MyTypography variant={"body3"} data-testid="docCurrency-text">
                  {dataExportOrder?.docCurrency}
                </MyTypography>
              </Grid>
              <Grid item md={6} sm={12}>
                <MyTypography
                  variant={"subtitle3"}
                  className={classes.titleField}
                >
                  {intl.formatMessage({ defaultMessage: "Terms of payment" })}
                </MyTypography>
                <MyTypography variant={"body3"} data-testid="paymentTerms-text">
                  {dataExportOrder?.paymentTerms}
                </MyTypography>
              </Grid>
              <Grid item md={6} sm={12}>
                <MyTypography
                  variant={"subtitle3"}
                  className={classes.titleField}
                >
                  {intl.formatMessage({ defaultMessage: "Incoterms" })}
                </MyTypography>
                <MyTypography variant={"body3"} data-testid="incoterms-text">
                  {dataExportOrder?.incoterms1}
                </MyTypography>
              </Grid>
              <Grid item md={6} sm={12} className={classes.selectField}>
                <MyTypography
                  variant={"subtitle3"}
                  className={classes.titleField}
                >
                  {intl.formatMessage({ defaultMessage: "Usage" })}
                </MyTypography>
                {viewEditMode === ViewEditMode.VIEW ? (
                  <MyTypography variant={"body3"} data-testid="usage-text">
                    {usageOptions.find(o => o.value === dataExportOrder?.usage)
                      ?.label || dataExportOrder?.usage}
                  </MyTypography>
                ) : (
                  // <SingleTextField
                  //   maxLengthProps={132}
                  //   name={"usage"}
                  //   value={formik.values.usage}
                  //   onChange={onChangeField}
                  // />
                  <SingleSelectField
                    name={"usage"}
                    id="usage"
                    InputProps={{
                      inputProps: { "data-testid": "usage-input" }
                    }}
                    menuListCustomStyle={{
                      overflowY: "auto"
                    }}
                    placeholder=""
                    choices={usageOptions}
                    value={formik.values.usage || ""}
                    onChange={onChangeField}
                    // maxLengthProps={132}
                  />
                )}
              </Grid>
              <Grid item md={6} sm={12}>
                <MyTypography
                  variant={"subtitle3"}
                  className={classes.titleField}
                >
                  {intl.formatMessage({ defaultMessage: "Unloading Point" })}
                </MyTypography>
                {viewEditMode === ViewEditMode.VIEW ? (
                  <MyTypography
                    variant={"body3"}
                    data-testid="unloadingPoint-text"
                  >
                    {dataExportOrder?.unloadingPoint}
                  </MyTypography>
                ) : (
                  <SingleTextField
                    maxLengthProps={132}
                    name={"unloadingPoint"}
                    id="unloadingPoint"
                    InputProps={{
                      inputProps: { "data-testid": "unloadingPoint-input" }
                    }}
                    value={formik.values.unloadingPoint}
                    onChange={onChangeField}
                  />
                )}
              </Grid>
              <Grid item md={6} sm={12}>
                <MyTypography
                  variant={"subtitle3"}
                  className={classes.titleField}
                >
                  {intl.formatMessage({ defaultMessage: "Place of Delivery" })}
                </MyTypography>
                {viewEditMode === ViewEditMode.VIEW ? (
                  <MyTypography
                    variant={"body3"}
                    data-testid="placeOfDelivery-text"
                  >
                    {dataExportOrder?.incoterms2}
                  </MyTypography>
                ) : (
                  <SingleTextField
                    maxLengthProps={132}
                    name={"placeOfDelivery"}
                    InputProps={{
                      inputProps: { "data-testid": "placeOfDelivery-input" }
                    }}
                    value={formik.values.placeOfDelivery}
                    onChange={onChangeField}
                    error={!!formik.errors.placeOfDelivery}
                  />
                )}
                {getTextError("placeOfDelivery")}
              </Grid>
              <Grid item md={6} sm={12}>
                <MyTypography
                  variant={"subtitle3"}
                  className={classes.titleField}
                >
                  {intl.formatMessage({ defaultMessage: "Port of Discharge" })}
                </MyTypography>
                {viewEditMode === ViewEditMode.VIEW ? (
                  <MyTypography
                    variant={"body3"}
                    data-testid="portOfDischarge-text"
                  >
                    {getPortOfDischarge()}
                  </MyTypography>
                ) : (
                  <SingleTextField
                    maxLengthProps={132}
                    name={"portOfDischarge"}
                    id="portOfDischarge"
                    InputProps={{
                      inputProps: { "data-testid": "portOfDischarge-input" }
                    }}
                    value={formik.values.portOfDischarge}
                    onChange={onChangeField}
                    error={!!formik.errors.portOfDischarge}
                  />
                )}
                {getTextError("portOfDischarge")}
              </Grid>
              <Grid item md={6} sm={12}>
                <MyTypography
                  variant={"subtitle3"}
                  className={classes.titleField}
                >
                  {intl.formatMessage({ defaultMessage: "Port of Loading" })}
                </MyTypography>
                {viewEditMode === ViewEditMode.VIEW ? (
                  <MyTypography
                    variant={"body3"}
                    data-testid="portOfLoading-text"
                  >
                    {getPortOfLoading()}
                  </MyTypography>
                ) : (
                  <SingleTextField
                    maxLengthProps={132}
                    name={"portOfLoading"}
                    id="portOfLoading"
                    InputProps={{
                      inputProps: { "data-testid": "portOfLoading-input" }
                    }}
                    value={formik.values.portOfLoading}
                    onChange={onChangeField}
                    error={!!formik.errors.portOfLoading}
                  />
                )}
                {getTextError("portOfLoading")}
              </Grid>
              <Grid item md={6} sm={12}>
                <MyTypography
                  variant={"subtitle3"}
                  className={classes.titleField}
                >
                  {intl.formatMessage({ defaultMessage: "No. of Containers" })}
                </MyTypography>
                {viewEditMode === ViewEditMode.VIEW ? (
                  <MyTypography
                    variant={"body3"}
                    data-testid="noOfContainers-text"
                  >
                    {getNoOfContainer()}
                  </MyTypography>
                ) : (
                  <SingleTextField
                    maxLengthProps={132}
                    name={"noOfContainers"}
                    id="noOfContainers"
                    InputProps={{
                      inputProps: { "data-testid": "noOfContainers-input" }
                    }}
                    value={formik.values.noOfContainers}
                    onChange={onChangeField}
                  />
                )}
              </Grid>
              <Grid item md={12} sm={12}>
                <MyTypography
                  variant={"subtitle3"}
                  className={classes.titleField}
                >
                  {intl.formatMessage({ defaultMessage: "Shipping Mark" })}
                </MyTypography>
                {/* <MyTypography
                  variant={"body3"}
                  className={classes.lineMultiText}
                >
                  {getShippingMark()}
                </MyTypography> */}
                <TextAreaField
                  value={formik.values.shippingMark}
                  name={"shippingMark"}
                  id="shippingMark"
                  data-testid="shippingMark-input"
                  onChange={onChangeField}
                  title={
                    <div className={classes.titleArea}>
                      <img src={iconComment} alt="icon-comment" />
                      <div>
                        {intl.formatMessage({ defaultMessage: "รายละเอียด" })}
                      </div>
                    </div>
                  }
                  viewOnly={viewEditMode === ViewEditMode.VIEW}
                  maxLength={1320}
                  lineLimit={132}
                  rowsMax={10}
                />
              </Grid>
              <Grid item md={6} sm={12} className={classes.selectField}>
                <MyTypography
                  variant={"subtitle3"}
                  className={classes.titleField}
                >
                  {intl.formatMessage({ defaultMessage: "UOM" })}
                </MyTypography>
                {viewEditMode === ViewEditMode.VIEW ? (
                  <MyTypography variant={"body3"} data-testid="uom-text">
                    {getUOM()}
                  </MyTypography>
                ) : (
                  <SingleTextField
                    maxLengthProps={132}
                    name={"uom"}
                    id="uom"
                    InputProps={{
                      inputProps: { "data-testid": "uom-input" }
                    }}
                    value={formik.values.uom}
                    onChange={onChangeField}
                  />
                )}
              </Grid>
              <Grid item md={6} sm={12} className={classes.selectField}>
                <MyTypography
                  variant={"subtitle3"}
                  className={classes.titleField}
                >
                  {intl.formatMessage({ defaultMessage: "G.W.UOM" })}
                </MyTypography>
                {viewEditMode === ViewEditMode.VIEW ? (
                  <MyTypography variant={"body3"} data-testid="gwUom-text">
                    {getGWUom()}
                  </MyTypography>
                ) : (
                  <SingleTextField
                    maxLengthProps={132}
                    name={"gwUom"}
                    id="gwUom"
                    InputProps={{
                      inputProps: { "data-testid": "gwUom-input" }
                    }}
                    value={formik.values.gwUom}
                    onChange={onChangeField}
                  />
                )}
              </Grid>
              <Grid item md={6} sm={12}>
                <MyTypography
                  variant={"subtitle3"}
                  className={classes.titleField}
                >
                  {intl.formatMessage({ defaultMessage: "ETD" })}
                </MyTypography>
                {viewEditMode === ViewEditMode.VIEW ? (
                  <MyTypography variant={"body3"} data-testid="etd-text">
                    {getETD() ? moment(getETD()).format("DD/MM/YYYY") : ""}
                  </MyTypography>
                ) : (
                  <DatePicker
                    name={"etd"}
                    id="etd"
                    data-testid="etd-input"
                    value={formik.values.etd}
                    onChange={handleChangeEtd}
                    error={!!formik.errors.etd}
                  />
                )}
                {getTextError("etd")}
              </Grid>
              <Grid item md={6} sm={12}>
                <MyTypography
                  variant={"subtitle3"}
                  className={classes.titleField}
                >
                  {intl.formatMessage({ defaultMessage: "ETA" })}
                </MyTypography>
                {viewEditMode === ViewEditMode.VIEW ? (
                  <MyTypography variant={"body3"} data-testid="eta-text">
                    {getETA() ? moment(getETA()).format("DD/MM/YYYY") : ""}
                  </MyTypography>
                ) : (
                  <DatePicker
                    name={"eta"}
                    id="eta"
                    data-testid="eta-input"
                    value={formik?.values?.eta}
                    onChange={handleChangeEta}
                    error={!!formik?.errors?.eta}
                  />
                )}
                {getTextError("eta")}
              </Grid>
              <Grid item md={6} sm={12}>
                <MyTypography
                  variant={"subtitle3"}
                  className={classes.titleField}
                >
                  {intl.formatMessage({
                    defaultMessage: "D-L/C : Expiry Date"
                  })}
                </MyTypography>
                {viewEditMode === ViewEditMode.VIEW ? (
                  <MyTypography
                    variant={"body3"}
                    data-testid="dlcExpiryDate-text"
                  >
                    {getDLCExpiryDate()
                      ? moment(getDLCExpiryDate()).format("DD/MM/YYYY")
                      : ""}
                  </MyTypography>
                ) : (
                  <DatePicker
                    name={"dlcExpiryDate"}
                    id="dlcExpiryDate"
                    data-testid="dlcExpiryDate-input"
                    value={formik.values.dlcExpiryDate}
                    onChange={onChangeField}
                  />
                )}
              </Grid>
              <Grid item md={6} sm={12}>
                <MyTypography
                  variant={"subtitle3"}
                  className={classes.titleField}
                >
                  {intl.formatMessage({ defaultMessage: "D-L/C No." })}
                </MyTypography>
                {viewEditMode === ViewEditMode.VIEW ? (
                  <MyTypography variant={"body3"} data-testid="dlcNo-text">
                    {getDLCNo()}
                  </MyTypography>
                ) : (
                  <SingleTextField
                    maxLengthProps={132}
                    name={"dlcNo"}
                    InputProps={{
                      inputProps: { "data-testid": "dlcNo-input" }
                    }}
                    value={formik.values.dlcNo}
                    onChange={onChangeField}
                  />
                )}
              </Grid>
              <Grid item md={6} sm={12}>
                <MyTypography
                  variant={"subtitle3"}
                  className={classes.titleField}
                >
                  {intl.formatMessage({
                    defaultMessage: "D-L/C : Latest Delivery Date"
                  })}
                </MyTypography>
                {viewEditMode === ViewEditMode.VIEW ? (
                  <MyTypography
                    variant={"body3"}
                    data-testid="dlcLatestDeliveryDate-text"
                  >
                    {getDLCLatestDeliveryDate()
                      ? moment(getDLCLatestDeliveryDate()).format("DD/MM/YYYY")
                      : ""}
                  </MyTypography>
                ) : (
                  <DatePicker
                    name={"dlcLatestDeliveryDate"}
                    id="dlcLatestDeliveryDate"
                    data-testid="dlcLatestDeliveryDate-input"
                    value={formik.values.dlcLatestDeliveryDate}
                    onChange={onChangeField}
                  />
                )}
              </Grid>
              <Grid item md={6} sm={12}>
                <MyTypography
                  variant={"subtitle3"}
                  className={classes.titleField}
                >
                  {intl.formatMessage({ defaultMessage: "Description" })}
                </MyTypography>
                {viewEditMode === ViewEditMode.VIEW ? (
                  <MyTypography
                    variant={"body3"}
                    data-testid="description-text"
                  >
                    {dataExportOrder?.description}
                  </MyTypography>
                ) : (
                  <SingleTextField
                    maxLengthProps={132}
                    name={"description"}
                    id="description"
                    InputProps={{
                      inputProps: { "data-testid": "description-input" }
                    }}
                    value={formik.values.description}
                    onChange={onChangeField}
                  />
                )}
              </Grid>
              <Grid item md={6} sm={12}>
                <MyTypography
                  variant={"subtitle3"}
                  className={classes.titleField}
                >
                  {intl.formatMessage({ defaultMessage: "End Customer" })}
                </MyTypography>
                <MyTypography variant={"body3"} data-testid="endCustomer-text">
                  {getEndCustomer()}
                </MyTypography>
              </Grid>
              <Grid item md={6} sm={12}>
                <MyTypography
                  variant={"subtitle3"}
                  className={classes.titleField}
                >
                  {intl.formatMessage({ defaultMessage: "Contact Person" })}
                </MyTypography>
                <MyTypography
                  variant={"body3"}
                  data-testid="contactPerson-text"
                >
                  {getContactPerson()}
                </MyTypography>
              </Grid>
              <Grid item md={6} sm={12}>
                <MyTypography
                  variant={"subtitle3"}
                  className={classes.titleField}
                >
                  {intl.formatMessage({ defaultMessage: "Sales Employee" })}
                </MyTypography>
                <MyTypography
                  variant={"body3"}
                  data-testid="salesEmployee-text"
                >
                  {getSalesEmployee()}
                </MyTypography>
              </Grid>
              <Grid item md={6} sm={12}>
                <MyTypography
                  variant={"subtitle3"}
                  className={classes.titleField}
                >
                  {intl.formatMessage({ defaultMessage: "Author" })}
                </MyTypography>
                <MyTypography variant={"body3"} data-testid="author-text">
                  {getAuthor()}
                </MyTypography>
              </Grid>
              <Grid item md={6} sm={12} />
            </Grid>
          </Grid>
          <Grid item md={6} sm={12}>
            <Grid container spacing={3}>
              <Grid item sm={12} className={classes.pickAddress}>
                <div className={classes.addressContent}>
                  <MyTypography
                    variant={"subtitle3"}
                    className={classes.titleField}
                  >
                    {intl.formatMessage({ defaultMessage: "Ship-to Party" })}
                  </MyTypography>
                  <MyTypography
                    variant={"body3"}
                    style={{
                      whiteSpace: "pre-line"
                    }}
                    data-testid="shipTo-text"
                  >
                    {formik.values.shipTo}
                  </MyTypography>
                </div>
                {viewEditMode === ViewEditMode.EDIT &&
                (mappedRealtimePartnerData?.filter(
                  e => e.partnerFunction === "WE"
                )?.length || 0) > 1 ? (
                  <Button
                    className={classes.btnEdit}
                    color={"secondary"}
                    variant={"outlined"}
                    onClick={() =>
                      handleOpenAddress(RealtimePartnerType.SHIP_TO)
                    }
                    name="edit-button"
                    id="edit-button"
                    data-testid="edit-button-shipTo"
                  >
                    <MyTypography variant={"body3"}>EDIT</MyTypography>
                  </Button>
                ) : (
                  ""
                )}
              </Grid>
              <Grid item sm={12} className={classes.pickAddress}>
                <div className={classes.addressContent}>
                  <MyTypography
                    variant={"subtitle3"}
                    className={classes.titleField}
                  >
                    {intl.formatMessage({ defaultMessage: "Bill-to Party" })}
                  </MyTypography>
                  <MyTypography
                    style={{
                      whiteSpace: "pre-line"
                    }}
                    variant={"body3"}
                    data-testid="billTo-text"
                  >
                    {formik.values.billTo}
                  </MyTypography>
                </div>
                {viewEditMode === ViewEditMode.EDIT &&
                (mappedRealtimePartnerData?.filter(
                  e => e.partnerFunction === "RE"
                )?.length || 0) > 1 ? (
                  <Button
                    className={classes.btnEdit}
                    color={"secondary"}
                    variant={"outlined"}
                    onClick={() =>
                      handleOpenAddress(RealtimePartnerType.BILL_TO)
                    }
                    name="edit-button"
                    id="edit-button"
                    data-testid="edit-button-billTo"
                  >
                    <MyTypography variant={"body3"}>EDIT</MyTypography>
                  </Button>
                ) : (
                  ""
                )}
              </Grid>
              <Grid item sm={12}>
                <MyTypography
                  variant={"subtitle3"}
                  className={classes.titleField}
                >
                  {intl.formatMessage({
                    defaultMessage: "Payer"
                  })}
                </MyTypography>
                {viewEditMode === ViewEditMode.VIEW ? (
                  <MyTypography variant={"body3"} data-testid="payer-text">
                    {getPayer()}
                  </MyTypography>
                ) : (
                  <SingleTextField
                    maxLengthProps={10}
                    name={"payer"}
                    id="payer"
                    InputProps={{
                      inputProps: { "data-testid": "payer-input" }
                    }}
                    value={formik.values.payer}
                    onChange={onChangeField}
                    error={!!formik.errors.payer}
                  />
                )}
                {getTextError("payer")}
              </Grid>
              <Grid item sm={12}>
                <MyTypography
                  variant={"subtitle3"}
                  className={classes.titleField}
                >
                  {intl.formatMessage({
                    defaultMessage: "Payment Instruction"
                  })}
                </MyTypography>
                <TextAreaField
                  value={formik.values.paymentInstruction}
                  name={"paymentInstruction"}
                  id="paymentInstruction"
                  data-testid="paymentInstruction-input"
                  onChange={onChangeField}
                  title={
                    <div className={classes.titleArea}>
                      <img src={iconComment} alt="icon-comment" />
                      <div>
                        {intl.formatMessage({ defaultMessage: "รายละเอียด" })}
                      </div>
                    </div>
                  }
                  viewOnly={viewEditMode === ViewEditMode.VIEW}
                  maxLength={1320}
                  lineLimit={132}
                  rowsMax={10}
                />
              </Grid>
              <Grid item sm={12}>
                <MyTypography
                  variant={"subtitle3"}
                  className={classes.titleField}
                >
                  {intl.formatMessage({ defaultMessage: "Remark" })}
                </MyTypography>
                <TextAreaField
                  value={formik.values.remark}
                  name={"remark"}
                  id="remark"
                  data-testid="remark-input"
                  onChange={onChangeField}
                  title={
                    <div className={classes.titleArea}>
                      <img src={iconComment} alt="icon-comment" />
                      <div>
                        {intl.formatMessage({ defaultMessage: "รายละเอียด" })}
                      </div>
                    </div>
                  }
                  viewOnly={viewEditMode === ViewEditMode.VIEW}
                  maxLength={1320}
                  lineLimit={132}
                  rowsMax={10}
                />
              </Grid>
              <Grid item sm={12}>
                <MyTypography
                  variant={"subtitle3"}
                  className={classes.titleField}
                >
                  {intl.formatMessage({
                    defaultMessage: "Production information"
                  })}
                </MyTypography>
                <TextAreaField
                  value={formik.values.productionInformation}
                  name={"productionInformation"}
                  id="productionInformation"
                  data-testid="productionInformation-input"
                  onChange={onChangeField}
                  title={
                    <div className={classes.titleArea}>
                      <img src={iconComment} alt="icon-comment" />
                      <div>
                        {intl.formatMessage({ defaultMessage: "รายละเอียด" })}
                      </div>
                    </div>
                  }
                  viewOnly={viewEditMode === ViewEditMode.VIEW}
                  maxLength={1320}
                  lineLimit={132}
                  rowsMax={10}
                />
              </Grid>
              <Grid item sm={12}>
                <MyTypography
                  variant={"subtitle3"}
                  className={classes.titleField}
                >
                  {intl.formatMessage({
                    defaultMessage: "Internal Comments to Warehouse"
                  })}
                </MyTypography>
                <TextAreaField
                  value={formik.values.internalCommentToWarehouse}
                  name={"internalCommentToWarehouse"}
                  id="internalCommentToWarehouse"
                  data-testid="internalCommentToWarehouse-input"
                  onChange={onChangeField}
                  title={
                    <div className={classes.titleArea}>
                      <img src={iconComment} alt="icon-comment" />
                      <div>
                        {intl.formatMessage({ defaultMessage: "รายละเอียด" })}
                      </div>
                    </div>
                  }
                  viewOnly={viewEditMode === ViewEditMode.VIEW}
                  maxLength={1320}
                  lineLimit={132}
                  rowsMax={10}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        {visibleModalAddress && (
          <ModalAddress
            address={addressOptions}
            // addressOptions
            handleApplyAddress={handleApplyAddress}
            type={typeAddress}
            visible={visibleModalAddress}
            onClose={() => setVisibleModalAddress(false)}
            formik={formik}
          />
        )}
        <DialogError
          onClose={() => setVisibleDialogError(false)}
          open={visibleDialogError}
        />
      </div>
    </div>
  );
};

export default memo(OrderHeaderTab);
